import BaseNoteTileView from "scripts/views/baseNoteTileView";
import templateNoteTile from "templates/noteTile.hbs";


class ContentDetailsPageAllNotesNoteTileView extends BaseNoteTileView {
  get tagName() {
    return "a";
  }

  get className() {
    return "note-card";
  }

  get template() {
    return templateNoteTile;
  }

  render() {
    this.$el.html(this.template(this.model.attributes));

    this.initIcon();

    return this;
  }

  /**
     * Page level notes display the page number.
     * Global notes display a globe icon.
     * Epub CFI notes have no icon.
     */
  initIcon() {
    if (this.model.has("pageSequence")) {
      // Page note
      this.$el.find(".bb-note-tile-page").removeClass("hide");
    } else if (!this.model.has("cfi")) {
      // Global note
      this.$el.find(".bb-note-tile-global").removeClass("hide");
    }
  }
}

export default ContentDetailsPageAllNotesNoteTileView;
